import { initContract } from "@ts-rest/core";
import { FileMetaDto, fileUploadInput } from "../validators/files.validator";

const c = initContract();

export const filesContract = c.router({
	uploadFile: {
		method: "POST",
		path: "/files",
		body: fileUploadInput,
		contentType: "multipart/form-data",
		responses: {
			201: c.type<FileMetaDto>(),
		},
		summary: "Upload a file",
	},
});
